import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

const Error = ({ error, setError }) => {

    const handleClose = () => {
        setError({ ...error, message: "", show: false });
    }

    return (
        <Dialog open={error.show} onClose={handleClose}>
            <DialogTitle sx={{ bgcolor: error.type === "success" ? 'success.main' : 'error.main', color: 'common.white' }}>
                {error.type === "success" ? "Success" : "Error"}
            </DialogTitle>
            <DialogContent sx={{ mt: 2 }}>{error.message}</DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={handleClose}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )
};

export default Error;
